export const routeConfig = {
  meta: {
    active: '1'
  }
};
